import React from 'react';
import {
  TableFilters,
  TableFilterSelect,
  BelongsToFilterSelects,
  InputContainer,
} from '../../design-system';
import { i18n } from '../../i18n';
import { extendContainerValidator } from '../../utils';
import { containerConditionOptions, containerTypes, INPUT_ERRORS } from '../../const';

interface Props {
  yardId?: string;
  clientId?: string;
  number?: string;
  type?: string;
  condition?: string;
  setStates: any;
}

export const Filters: React.FC<Props> = ({ number = '', type, condition, setStates }: Props) => {
  return (
    <TableFilters>
      <BelongsToFilterSelects
        handleChange={(obj) => {
          setStates('force', obj);
        }}
        filtersType={'marketplace'}
      />
      {!Array.isArray(number) && (
        <InputContainer
          label={i18n.t('label.containerNumber')}
          data-size={'medium'}
          defaultValue={number}
          onChange={(e) => {
            const value = e.target.value.toUpperCase();
            setStates('number', value);
          }}
          helperText={
            number.length !== 0 && number.length < 3
              ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_MIN
              : !extendContainerValidator(number)
              ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_SHORT
              : ''
          }
          alwaysShowHelperText
        />
      )}
      <TableFilterSelect
        label={i18n.t('label.type')}
        options={containerTypes}
        value={type}
        onChange={(e) => setStates('force', { type: e.target.value })}
      />
      <TableFilterSelect
        label={i18n.t('label.condition')}
        options={containerConditionOptions}
        value={condition}
        onChange={(e) => setStates('force', { condition: e.target.value })}
      />
    </TableFilters>
  );
};
